import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, ThemeProvider } from '@mui/material';

import { passengerThemeV2 } from '@mopla/mui';
import { DTicketPageLayout } from '@mopla/ui';

import { OperatorCardSkeleton } from './components';

interface ITicketshopLoadingProps {
	onBack: () => void;
}

export const TicketshopLoading: FC<ITicketshopLoadingProps> = ({ onBack }) => {
	const { t } = useTranslation('ticketshop');

	return (
		<ThemeProvider theme={passengerThemeV2}>
			<DTicketPageLayout
				title={t('page_title')}
				onBack={onBack}
				scrollable
				dataTestId="ticketshop-page-loading"
			>
				<Stack gap={2}>
					<OperatorCardSkeleton />
					<OperatorCardSkeleton />
				</Stack>
			</DTicketPageLayout>
		</ThemeProvider>
	);
};
